import { ReactNode, useMemo } from "react";
import { ApolloProvider } from "@/app/providers/apollo-provider";
import { EchoProvider } from "@/app/providers/echo-provider";
import { TranslationProvider, useTranslation } from "@/shared/i18n";
import { TourProvider } from "@/shared/ui/tour";
import { getOnboardingTour } from "@/features/app-tour";
import { ThemeSync } from "@/features/appearance";

type Props = {
  children: ReactNode;
};

const TranslatedTourProvider = ({ children }: { children: ReactNode }) => {
  const { t } = useTranslation();
  const tours = useMemo(() => [getOnboardingTour(t)], [t]);

  return <TourProvider tours={tours}>{children}</TourProvider>;
};

export const RootProvider = ({ children }: Props) => {
  return (
    <ApolloProvider>
      <EchoProvider>
        <TranslationProvider>
          <ThemeSync />
          <TranslatedTourProvider>{children}</TranslatedTourProvider>
        </TranslationProvider>
      </EchoProvider>
    </ApolloProvider>
  );
};
